/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, Fragment } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from 'clsx';
import { Col, Row, Image, Space, Modal, } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams, NavLink } from "react-router-dom";
import { checkCRUDViewPermission, checkComponentPermission, idNamingConversion, downloadTitle, currencyFormat, gstCalculation } from "../../../../../helpers/utilities";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { Typography, Tooltip, IconButton, TextField, FormControlLabel, Switch, Box, Button } from '@mui/material';
import { InvoiceLinesList } from "./Block";
import { AESDecrypt } from "../../../../../helpers/Crypto";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../Shared/components/Icons/Date";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import gstActions from "../../../../Admin/Setup/redux/actions";
import moment from 'moment';
import { toast } from 'react-toastify';
import InvoiceModal from "../../../../Shared/components/InvoiceModal";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { templateType } from '../../../../../config/constant';


export default function DeliveryNoteInvoice(props) {
    const { partyGstdetails, productGstdetails, hsnDetails } = useSelector(state => state.adminSetupReducer);
    const { readDetails, editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const [showDetails, setShowDetails] = useState(true);
    const dispatch = useDispatch();
    const { history } = props;
    const { deliveryDetails } = useParams();
    const decryptedValues = AESDecrypt(deliveryDetails);
    const prevReadDetails = usePrevious(readDetails);
    const [loadMore, setLoadMore] = useState(false);
    const [lines, setLines] = useState([]);
    const [selected, setSelected] = useState([]);
    const [changeSelected, setChangeSelected] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const prevEditError = usePrevious(editError);
    const prevEditDetails = usePrevious(editDetails);
    const [preview, setPreview] = useState(false);
    const [open, setOpen] = useState(false);

    const [form, setForm] = useState({});

    const [error, setError] = useState({});

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }
    useEffect(() => {
        if (deliveryDetails === undefined) {
            history.push("/sales/transactions/delivery-note");
            return true;
        }

        if (roleManagement !== '' && checkCRUDViewPermission('Delivery Note History', 'view', history, 'Sales')) {
            dispatch({
                type: gstActions.PRODUCTGST_DETAILS_START, url: 'productgst', filter: {
                    order: 'id desc'
                }
            });
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedValues?.deliveryId, url: "v1/sales-delivery/sales-deliveries" });
            // dispatch({
            //     type: crudActions.GET_DETAILS_START,
            //     url: 'v1/sales-delivery/sales-delivery-line-items',
            //     skip: 0,
            //     filter: {
            //         where: { salesDeliveryId: { inq: decryptedValues?.deliveryIds } },
            //         order: 'createTs desc'
            //     }
            // })
        }
    }, [roleManagement, deliveryDetails]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            setDataPreview(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            toast.error(text);
        }
    }, [editDetails, editError]);

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            setLoadMore(true);
            if (readDetails?.salesDeliveryLineItems) {
                setLines(readDetails?.salesDeliveryLineItems?.map(item => ({
                    ...item,
                    invoice_quantity: (item.available_quantity || 0), // update logic
                    invoice_unitPrice: (item.pricePerUnit || 0),
                    invoice_netAmount: (item.amount || 0),
                    available_quantity: 0,
                    duplicate_available_quantity: item?.available_quantity || 0
                })).sort((a, b) => a.lineNumber - b.lineNumber));
            }
            let a = [];
            readDetails?.salesDeliveryLineItems?.length > 0 && readDetails?.salesDeliveryLineItems?.map((el) => {
                return a.push(el.id);
            });
            setSelected([...a]);
            const { salesDeliveryLineItems, ...rest } = readDetails || {};
            setForm({
                ...rest,
                areaId: rest?.areaId || 0,
                billFormat: 'format1',
                invoiceDate: new Date(),
                dueDate: new Date(),
                roundOffMethod: '', roundOffAmount: 0
            });
            setChangeSelected(!changeSelected);
        }
    }, [readDetails]);

    const changeHandler = (e, name) => {
        if (name === 'roundOffMethod') {
            let value = 0;
            if (form?.totalInvoiceAmount && e !== '') {
                if (e === 'UP') {
                    value = Math.ceil(form?.totalInvoiceAmount || 0);
                } else {
                    value = Math.floor(form?.totalInvoiceAmount || 0);
                }
            }
            setForm({
                ...form,
                [name]: e,
                'roundOffAmount': value ? parseFloat(parseFloat(value - form?.totalInvoiceAmount).toFixed(2)) : 0,
                'invoiceAmount': value ? parseFloat(parseFloat(value).toFixed(2)) : form?.totalInvoiceAmount
            });
        } else if (name === 'roundOffAmount') {
            setForm({
                ...form,
                [name]: e,
                'invoiceAmount': parseFloat(parseFloat(form?.totalInvoiceAmount + parseFloat(e || 0)).toFixed(2))
            });
        } else {
            setForm({
                ...form,
                [name]: e
            });
        }
    }

    const changeHandlerLine = (data, e, name = '') => {
        const newTodos = lines.map((el) => {
            if (el.id === data.id) {
                if (name === 'invoice_quantity') {
                    return { ...el, [name]: e, 'available_quantity': parseFloat(parseFloat(data.duplicate_available_quantity) - parseFloat(e)) };
                } else {
                    return { ...el, [name]: e };
                }
            }
            return el;
        });
        setLines(newTodos);
        setChangeSelected(!changeSelected);
    }

    const handleClick = (data) => {
        const selectedIndex = selected.indexOf(data.id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setForm({
            ...form,
            ...calculateGrandTotal(form, lines?.filter((el) => { return newSelected.find((e) => e === el.id) }))
        });
        setSelected(newSelected);
    }

    useEffect(() => {
        if (lines && lines?.length > 0) {
            const newTodos = lines.map((el) => {
                return calculateLineTotal(el, form);
            });
            setForm({
                ...form,
                ...calculateGrandTotal(form, newTodos?.filter((el) => { return selected.find((e) => e === el.id) }))
            });
            setLines(newTodos);
        }
    }, [changeSelected]);

    const calculateLineTotal = (el, form) => {
        let data = {
            cgst: '', sgst: '', igst: '', cgstPercentage: '', sgstPercentage: '', igstPercentage: ''
        };
        const amount = el.invoice_quantity * el.invoice_unitPrice;
        let dPAmount = 0;
        let dTotal = 0;
        let gAmount = 0;

        if (el.discountPercent !== '') {
            dPAmount = dTotal = parseFloat((amount * el.discountPercent) / 100);
        }
        if (el.discountAmount && el.discountAmount !== '') {
            if (amount < 0) {
                dTotal = parseFloat(dPAmount) - parseFloat(el.discountAmount);
            } else {
                dTotal = parseFloat(dPAmount) + parseFloat(el.discountAmount);
            }
        }
        let tAmount = (amount - dTotal);
        data['invoice_netAmount'] = tAmount;

        if (el?.productGst && el.includeGst) {
            let percentage = el?.productGst?.percentage || 0;
            let details = {
                percentage: percentage,
                stateId: form?.customer?.stateId,
                lineAmount: tAmount || 0, priceIncludesTax: form?.priceIncludesTax || false,
            };
            let gstCalc = gstCalculation(form?.business, details, form?.customer);
            data['cgstPercentage'] = parseFloat(gstCalc.cgst);
            data['sgstPercentage'] = parseFloat(gstCalc.sgst);
            data['igstPercentage'] = parseFloat(gstCalc.igst);
            data['cgst'] = parseFloat(gstCalc.cgstAmount);
            data['sgst'] = parseFloat(gstCalc.sgstAmount);
            data['igst'] = parseFloat(gstCalc.igstAmount);
            gAmount = gstCalc.gAmount;
        }

        let result = {
            ...el,
            ...data,
            gstAmount: parseFloat(gAmount),
            discountPercAmount: dPAmount,
            discountCalcAmount: dTotal
        };
        return result;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        handleCommonSubmit(form?.OrderStatus);
    }


    const lineSubmit = (data, lineId = '') => {
        if (lineId !== '') {
            let index = lines.findIndex((d, i) => lineId === i);
            if (index >= 0) {
                lines.splice(index, 1, data);
            }
        } else {
            setLines((prevState) => {
                return [...prevState, data];
            });
        }
        setChangeSelected(!changeSelected);
    }

    const hsnApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: gstActions.HSN_DETAILS_START, filter: {
                where: filter,
                order: 'hsnCode asc',
                limit: 500,
                skip: 0
            },
        });
    }

    const handleIncludeGst = (value) => {
        if (!value) {
            setModalVisible(true);
        } else {
            setForm({
                ...form, includeGst: value
            });
            lines && lines.length > 0 && lines.forEach((element, i) => {
                let party = partyGstdetails && partyGstdetails.filter(function (el) { return el.id === form?.partyGstId });
                if (party.length >= 0) {
                    if (element.productGstId) {
                        let p = party[0].productGsts && party[0].productGsts.filter(function (el) { return el.id === element.productGstId });
                        if (p.length >= 0) {
                            let percentage = p[0].percentage;
                            let details = {
                                percentage: percentage,
                                stateId: form?.stateId,
                                lineAmount: element.amount, priceIncludesTax: form?.priceIncludesTax || false,
                            };
                            let gstCalc = gstCalculation(form?.business, details, form?.customer);
                            let mLines = {
                                ...element,
                                includeGst: true,
                                igstPercentage: parseFloat(gstCalc?.igst || 0),
                                cgstPercentage: parseFloat(gstCalc?.cgst || 0),
                                sgstPercentage: parseFloat(gstCalc?.sgst || 0),
                                cgst: parseFloat(gstCalc?.cgstAmount || 0),
                                sgst: parseFloat(gstCalc?.sgstAmount || 0),
                                igst: parseFloat(gstCalc?.igstAmount || 0),
                                gstAmount: parseFloat(gstCalc.gAmount || 0),
                            };

                            return lines.splice(i, 1, mLines);
                        }
                    }
                }
            });
        }
    }

    const handleWarningYes = () => {
        setModalVisible(false);
        setForm({
            ...form, includeGst: false
        });
        lines && lines.length > 0 && lines.map((element, i) => {
            let mLines = {
                ...element,
                includeGst: false,
                igstPercentage: 0,
                cgstPercentage: 0,
                sgstPercentage: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                gstAmount: 0,
            };
            return lines.splice(i, 1, mLines);
        });
    }

    const handleCommonSubmit = (status, callDispatch = true) => {
        let dueDateCheck = moment(moment(form.dueDate).format('YYYY-MM-DD')).isSameOrAfter(moment(form.invoiceDate).format('YYYY-MM-DD'));
        setError({});
        if (dueDateCheck) {
            let a = [];

            lines && lines?.length > 0 && lines?.filter((el) => { return selected.find((e) => e === el.id) })?.map((element, i) => {
                return a.push({ ...element })
            });
            form.salesDeliveryLineItems = a;
            let subForm = { ...form };

            if (callDispatch) {
                delete subForm.includeDisabled; delete subForm.currency; delete subForm.area; delete subForm.city;
                delete subForm.state; delete subForm.country; delete subForm.netAmount; delete subForm.totalDiscount;
                delete subForm.business; delete subForm.partyGst; delete subForm.mop; delete subForm.pincode; delete subForm.invoice_billFormatDisabled;
                delete subForm.customer; delete subForm.inAppStatus; delete subForm.createdBy; delete subForm.businessDocumentTemplates;
                delete subForm.updatedBy; delete subForm.createTs; delete subForm.updateTs; delete subForm.id; delete subForm.origin; delete subForm.manualInvoiceNo;
                delete subForm.totalInvoiceAmount; delete subForm.isViaNotification; delete subForm.version; delete subForm.supplyOrderId; delete subForm.gstin;
                if (lines.length === form.salesDeliveryLineItems.filter(el => el.available_quantity === 0).length) {
                    subForm.deliveryStatus = 'INVOICED';
                }
                a?.length > 0 && a?.map((element, i) => {
                    element.lineStatus = 'INVOICED';
                    delete element.cgstAmount;
                    delete element.discountCalcAmount;
                    delete element.discountPercAmount;
                    delete element.igstAmount;
                    delete element.number;
                    delete element.productUnitId;
                    delete element.sgstAmount;
                    delete element.useMrp;
                    delete element.hsn;
                    delete element.unit;
                    delete element.product;
                    delete element.productGst;
                    delete element.productUnit;
                    delete element.universalProduct;
                    return a.splice(i, 1, { ...element });
                });
                subForm.salesDeliveryLineItems = a;
                subForm.roundOffMethod = subForm?.roundOffMethod || null;
                subForm.taxCodeId = subForm?.taxCodeId || 0;
                subForm.tcsNameId = subForm?.tcsNameId || 0;
                dispatch({
                    type: crudActions.EDIT_DETAILS_START,
                    url: 'v1/sales-delivery/sales-deliveries',
                    title: 'Sales Invoice',
                    id: form?.id,
                    slug: 'invoice',
                    details: subForm
                })
            } else {
                return subForm;
            }
        } else {
            setError({
                dueDate: !dueDateCheck ? 'Due Date should greater or equal to Invoice date' : '',
            });
        }
    }

    const calculateGrandTotal = (form, lines) => {
        let data = {};
        if (lines && lines.length > 0) {
            let total = lines && lines.reduce((a, v) => a = a + v.invoice_netAmount, 0);
            let discount = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v.discountAmount), 0);
            let discountPercent = lines && lines.reduce((a, v) => {
                if (v.amount < 0) {
                    a = parseFloat(a) - parseFloat(((v.invoice_quantity * v.pricePerUnit) * v.discountPercent) / 100)
                } else {
                    a = parseFloat(a) + parseFloat(((v.invoice_quantity * v.pricePerUnit) * v.discountPercent) / 100)
                }
                return a;
            }, 0);
            let gst = lines && lines.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0);
            if (form?.priceIncludesTax) {
                data['invoiceAmount'] = total + form?.roundOffAmount;
                data['totalInvoiceAmount'] = total;
                data['netAmount'] = total - gst;
            } else {
                data['invoiceAmount'] = total + gst + form?.roundOffAmount;
                data['totalInvoiceAmount'] = total + gst;
                data['netAmount'] = total;
            }
            data['totalDiscount'] = discount + discountPercent;
            data['gstAmount'] = gst;
        } else {
            data['invoiceAmount'] = 0;
            data['totalDiscount'] = parseFloat(0.00);
            data['gstAmount'] = parseFloat(0.00);
            data['netAmount'] = parseFloat(0.00);
        }
        return {
            ...form, ...data
        }
    }

    const handlePreview = () => {
        setDataPreview();
    }

    const setDataPreview = (a = true) => {
        let data = handleCommonSubmit('CREATED', false);
        if (data) {
            const newTodos = data?.salesDeliveryLineItems?.length > 0 ? data?.salesDeliveryLineItems.map((el, i) => {
                return {
                    ...el,
                    //'lineNumber': (i + 1),
                    'quantity': el.invoice_quantity,
                    'pricePerUnit': el.invoice_unitPrice,
                    'amount': el.invoice_netAmount
                };
            }) : [];
            data.selfBillItems = newTodos;
            data.currency = data.salesOrder?.currency;
            data.serialNo = '';
            console.log(data);
            setPreviewData(data);
            setPreview(a);
            setOpen(true);
        }
    }

    useEffect(() => {
        if (preview) {
            setDataPreview();
        }
    }, [preview]);

    const handleModalClose = (o) => {
        setOpen(o); setPreview(false);
    };


    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'} img={SalesIcon} title={'Sales'} links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Delivery Note History', 'link': '' }, { 'label': 'Create Invoice', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Create Invoice'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={!loadMore}
                        index={0}
                        component={
                            <Box
                                className={clsx(classes.removeUnderline, classes.positionRelative)}
                                component="form"
                                autoComplete="off"
                                onSubmit={(e) => handleSubmit(e)}>
                                {
                                    !loadMore ? <div style={{ textAlign: "center" }}>
                                        <div className={classes.loadMoreCircle}></div>
                                    </div> :
                                        <>
                                            <div className={clsx(classes.tabWrapSubmit)}>
                                                <Space size={[20, 20]} direction="horizontal" align="center">
                                                    <div className={classes.templateView} >
                                                        <NavLink to="#" onClick={() => handlePreview()} tabIndex={-1}>
                                                            <Image tabIndex={-1} className={""} src={ViewIcon} preview={false} />
                                                            <span className={classes.customerInvoiceNone}>Invoice Template</span>
                                                        </NavLink>
                                                        <AutoCompleteComponent
                                                            name={""}
                                                            id={idNamingConversion('billFormat', 'salesBill', 'DropDown')}
                                                            heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                            details={templateType}
                                                            parentValue={customObject(templateType, form?.billFormat)}
                                                            onChange={(data) => { changeHandler(data.id, 'billFormat'); handlePreview(); }}
                                                            position={'bottom'}
                                                            customClasses={clsx(classes.customAutocomplete, classes.customerInvoice)}
                                                        />
                                                    </div>
                                                    {
                                                        roleManagement !== '' && checkComponentPermission('Sales Order', 'Page', 'Confirm') && form?.invoiceAmount > 0 &&
                                                        <Button
                                                            tabIndex={-1}
                                                            key="Save"
                                                            type="submit"
                                                            color="primary"
                                                            variant="contained"
                                                            className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}>Confirm</Button>
                                                    }
                                                </Space>
                                            </div>
                                            <Row>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                                </Col>
                                            </Row>
                                            <Row gutter={50}>
                                                <Col xxl={5} xl={5} lg={5} md={65} sm={12} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer Name</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer_name || '----'}</Typography>
                                                </Col>
                                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer Phone</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer_phone || '----'}</Typography>
                                                </Col>
                                                <Col xxl={14} xl={14} lg={14} md={14} sm={12} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer Email</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customer_email || '----'}</Typography>
                                                </Col>
                                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                    <div className={clsx(classes.margin30t, classes.dateAdjust)} tabIndex={-1}>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DesktopDatePicker
                                                                fullWidth
                                                                slots={{
                                                                    openPickerIcon: DateIcon
                                                                }}
                                                                views={['year', 'month', 'day']}
                                                                value={form?.invoiceDate || null}
                                                                // maxDate={validDate}
                                                                label="Invoice Date"
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    }
                                                                }}
                                                                slotProps={{
                                                                    textField: {
                                                                        id: idNamingConversion('Invoice Date', 'salesOrder', 'TextField'),
                                                                        autoComplete: 'one-time-code'
                                                                    },
                                                                }}
                                                                //readOnly={true}
                                                                format="dd/MM/yyyy"
                                                                onChange={(newValue, newError) => {
                                                                    if (newError?.validationError || newValue === null) {
                                                                        changeHandler(new Date(), 'invoiceDate');
                                                                    } else {
                                                                        changeHandler(newValue, 'invoiceDate');
                                                                    }
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                </Col>
                                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                    <div className={clsx(classes.margin30t, classes.dateAdjust)} tabIndex={-1}>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DesktopDatePicker
                                                                fullWidth
                                                                slots={{
                                                                    openPickerIcon: DateIcon
                                                                }}
                                                                views={['year', 'month', 'day']}
                                                                value={form?.dueDate || null}
                                                                minDate={form?.invoiceDate}
                                                                label="Due Date"
                                                                InputProps={{
                                                                    classes: {
                                                                        input: classes.textFieldColor,
                                                                    }
                                                                }}
                                                                slotProps={{
                                                                    textField: {
                                                                        error: error?.dueDate ? true : false,
                                                                        helperText: error?.dueDate,
                                                                        id: idNamingConversion('Due Date', 'salesOrder', 'TextField'),
                                                                        autoComplete: 'one-time-code'
                                                                    },
                                                                }}
                                                                //readOnly={true}
                                                                format="dd/MM/yyyy"
                                                                onChange={(newValue, newError) => {
                                                                    if (newError?.validationError || newValue === null) {
                                                                        changeHandler(new Date(), 'dueDate');
                                                                    } else {
                                                                        changeHandler(newValue, 'dueDate');
                                                                    }
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row gutter={50}>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.margin35t, classes.bold)}>GST Details</Typography>
                                                </Col>
                                                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                                                    <FormControlLabel
                                                        classes={{
                                                            label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                                        }}
                                                        id={idNamingConversion('Tax Invoice', 'salesOrder', 'Radio')}
                                                        control={<Switch size='small'
                                                            className={clsx(classes.customSwitch)}
                                                            onChange={(e) => handleIncludeGst(!form?.includeGst)}
                                                        />}
                                                        label="Tax Invoice"
                                                        labelPlacement="top"
                                                        checked={form?.includeGst}
                                                        disabled={form?.includeDisabled}
                                                        className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={50}>
                                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Totals</Typography>
                                                </Col>
                                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Discount</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.totalDiscount || 0)}</Typography>
                                                </Col>
                                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Net Amount</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.netAmount || 0)}</Typography>
                                                </Col>
                                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                                        <span>GST Amount </span>
                                                        <Tooltip tabIndex={-1}
                                                            classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                                            title={'Rounded to 2 decimal places'} arrow placement="top"
                                                            className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                            <IconButton>
                                                                <Image src={infoMarkIcon} preview={false} />
                                                            </IconButton>
                                                        </Tooltip> </Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.gstAmount || 0)}</Typography>
                                                </Col>
                                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                                                    <Row>
                                                        <Col xxl={8} xl={10} lg={10} md={8} sm={6} xs={6}>
                                                            <AutoCompleteComponent
                                                                name={["Round Off"]}
                                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                                details={[{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }]}
                                                                id={idNamingConversion('Round off', 'salesOrder', 'DropDown')}
                                                                parentValue={customObject([{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }], form?.roundOffMethod)}
                                                                onChange={(data) => changeHandler(data?.id, 'roundOffMethod')}
                                                                position={"bottom"}
                                                                customClasses={classes.margin20t}
                                                            />
                                                        </Col>
                                                        <Col xxl={16} xl={14} lg={14} md={16} sm={18} xs={18}>
                                                            <TextField autoComplete='one-time-code'
                                                                label={[""]}
                                                                fullWidth
                                                                type="number"
                                                                id={idNamingConversion('Round Off Amount', 'salesOrder', 'TextField')}
                                                                className={clsx(classes.margin20t)}
                                                                error={error?.roundOffAmount && true}
                                                                helperText={error?.roundOffAmount}
                                                                variant={'standard'}
                                                                name="roundOffAmount"
                                                                value={form.roundOffAmount}
                                                                InputProps={{
                                                                    classes: {
                                                                        input: clsx(classes.textFieldColor, classes.padding10L)
                                                                    }
                                                                }}
                                                                inputProps={{
                                                                    step: "any",
                                                                    "aria-autocomplete": "none"
                                                                }}
                                                                InputLabelProps={{
                                                                    className: classes.textFieldLableColorCustom
                                                                }}
                                                                disabled={form?.roundOffMethod ? false : true}
                                                                onChange={(e) => changeHandler(e.target.value, 'roundOffAmount')}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Invoice Amount</Typography>
                                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.invoiceAmount || 0)}</Typography>
                                                </Col>
                                            </Row>
                                        </>
                                }
                            </Box>
                        }
                    />
                    <CustomAccordion
                        title={'Invoice Lines'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={loadMore}
                        index={1}
                        component={
                            <>
                                {
                                    !loadMore ? <div className={classes.textAlignCenter}>
                                        <div className={classes.loadMoreCircle}></div>
                                    </div > : <>
                                        <InvoiceLinesList
                                            classes={classes}
                                            clsx={clsx}
                                            loadMore={loadMore}
                                            lines={lines}
                                            form={form}
                                            selected={selected}
                                            handleIncludeGst={(v) => handleIncludeGst(v)}
                                            productGstdetails={productGstdetails}
                                            hsnDetails={hsnDetails}
                                            single={decryptedValues?.single || false}
                                            hsnApi={(s = '', id = '') => hsnApi(s, id)}
                                            handleClick={(data) => handleClick(data)}
                                            customObject={(details, id) => customObject(details, id)}
                                            idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                            roleManagement={roleManagement}
                                            lineSubmit={(data, id) => lineSubmit(data, id)}
                                            calculateLineTotal={(el, form) => calculateLineTotal(el, form)}
                                            changeHandlerLine={(data, e, name = '') => changeHandlerLine(data, e, name)}
                                            checkComponentPermission={(v, page, d) => checkComponentPermission(v, page, d)}
                                        />
                                    </>
                                }
                            </>
                        }
                    />
                    <Modal
                        title={'Warning message'}
                        open={modalVisible}
                        onOk={() => setModalVisible(false)}
                        onCancel={() => setModalVisible(false)}
                        footer={
                            [
                                <Space direction="horizontal" align="center">
                                    <NavLink
                                        to={`#`} onClick={() => handleWarningYes()}
                                        className={clsx(classes.AddMoreBtn, classes.bold, classes.textAlignLeft)}
                                    >Yes</NavLink>
                                    <NavLink
                                        to={`#`} onClick={() => setModalVisible(false)}
                                        className={clsx(classes.modalBtn, classes.bold, classes.textAlignLeft)}
                                    >No</NavLink>
                                </Space>
                            ]}
                        className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)} >
                        <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>Please note, changing the Tax Invoice to "No" should comply to GST law. Are you sure you want to continue to make this change ?</Typography>
                    </Modal>
                </div>
            </div>
            {
                open &&
                <InvoiceModal open={open}
                    title={downloadTitle(previewData, 'sales-bill')}
                    handleClose={(o) => handleModalClose(o)}
                    link={preview ? '' : `/sales/transactions/delivery-note/${decryptedValues?.deliveryId}/view`}
                    {...props}
                    type={"create"}
                    proformaPreview={preview}
                    format={previewData?.billFormat || 'format1'}
                    priceIncludesTax={previewData?.business?.priceIncludesTax}
                    details={previewData} />
            }
        </Fragment>
    )
}